







import { Component, Mixins } from 'vue-property-decorator';
import CompanyBuildings from '@/components/companies/CompanyBuildings.vue';
import Mixin from '@/mixins/base';
import DashboardBreadcrumbs from '@/components/breadcrumbs/DashboardBreadcrumbs.vue';

@Component({
  mixins: [Mixin],
  components: {
    'dashboard-breadcrumbs': DashboardBreadcrumbs,
    'company-buildings': CompanyBuildings
  }
})
export default class CompanyBuildingsView extends Mixins(Mixin) {
  get companyId(): string | number {
    return this.$route.params.companyId;
  }
}
